import MainComponent from "components/Main";

import ItemPerson from 'components/ItemPerson';

export default class ItemClient extends MainComponent {

    getSecondRow({ birthday, phoneNumber }) {
        let bt = "";
        if (birthday)
            bt = this._helper.date.toDateStr(birthday) + ", ";

        return bt + this._helper.string.fromatPhone(phoneNumber);
    }

    render() {
        return (
            <ItemPerson
                {...this.props}
                secondRow={this.getSecondRow(this.props.info)}
            />
        );
    }
}
